import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {DataInfo} from 'presentation/components';
import {usePersonalData} from 'presentation/hooks';
import {ConfirmationCard} from 'presentation/pages/private/booking/components';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {formatMasks, formatText, getUserInfoFromToken} from 'presentation/utils';

const {beneficiaryPlan, contactInfo} = translations['pt-br'].commons;

const {
	cardData: {cardCode},
} = translations['pt-br'].privateFlow.healthCard;
const {beneficiaryData} = translations['pt-br'].privateFlow.bookingFlow;

export function BeneficiaryInfoCard() {
	const {colors} = useTheme();

	const {
		beneficiary: {nmPlano, nmSocialUsuarioC, nmUsuarioC},
	} = useAccountDataStore(store => store.accountData);
	const {currentEmail, currentPhone} = usePersonalData();

	const {cdUsuario} = getUserInfoFromToken();

	return (
		<Stack gap={2}>
			<Typography variant="subtitle2" color={colors.light.text.secondary}>
				{beneficiaryData}
			</Typography>
			<ConfirmationCard.Root>
				<ConfirmationCard.Header subheader={beneficiaryPlan} />
				<ConfirmationCard.Content
					iconName="account-circle-filled"
					primaryText={formatText(nmSocialUsuarioC || nmUsuarioC)}>
					<DataInfo
						primaryText={nmPlano}
						iconName="hapvida-logo"
						secondaryText={`${cardCode}: ${cdUsuario}`}
						listItemProps={{sx: {p: 0}}}
					/>
				</ConfirmationCard.Content>
			</ConfirmationCard.Root>
			<ConfirmationCard.Root>
				<ConfirmationCard.Header subheader={contactInfo} />
				<Stack>
					<DataInfo
						primaryText={formatMasks('phone', currentPhone)}
						iconName="phone-android-filled"
						listItemProps={{sx: {p: 0}}}
						removePaddingBottom
					/>
					<DataInfo
						primaryText={currentEmail}
						iconName="mail-filled"
						listItemProps={{sx: {p: 0}}}
					/>
				</Stack>
			</ConfirmationCard.Root>
		</Stack>
	);
}
